import React from 'react';
import { Header } from 'semantic-ui-react';

import ConnectedCreateKeyModal from './create-key-modal';

export default () => (
  <div className="re is-header is-flex is-flex-row is-flex-justify-space-between">
    <Header as="h1" className="re is-header-item">
      Manage your Remeeting API Keys
    </Header>
    <div>
      <ConnectedCreateKeyModal />
    </div>
  </div>
);
